import { useId } from "react";

interface CustomFoodCreatorOrdersIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export function CustomFoodCreatorOrdersIcon({
  size = 36,
  color = "#094327",
  className,
}: CustomFoodCreatorOrdersIconProps) {
  const gradientId = useId().replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 36"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="15.534" y1="0" x2="15.534" y2="36" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FAFFFA" stopOpacity="0.2" />
          <stop offset="1" stopColor="#FF3B30" stopOpacity="0.55" />
        </linearGradient>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18755 6.78841L3.24175 14.2459C0.747176 17.3747 -0.500103 18.9391 0.187166 20.169C0.198545 20.1896 0.210273 20.2097 0.222331 20.2297C0.950377 21.4411 3.10457 21.4411 7.41298 21.4411C9.80719 21.4411 11.0043 21.4411 11.7551 22.0958L11.794 22.1303L19.3123 13.9044L19.2734 13.8698C18.5383 13.201 18.5383 12.1347 18.5383 10.0023V9.44483C18.5383 3.53249 18.5383 0.576329 16.7455 0.0669825C14.9526 -0.442346 13.0308 1.96789 9.18755 6.78841Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M12.5294 25.9978V26.5551C12.5294 32.4673 12.5294 35.4237 14.3222 35.9329C16.1151 36.4423 18.0368 34.0321 21.8803 29.2115L27.826 21.7541C30.3207 18.6253 31.5679 17.0609 30.8807 15.8308C30.8692 15.8105 30.8576 15.7903 30.8456 15.7703C30.1174 14.5589 27.9633 14.5589 23.6548 14.5589C21.2607 14.5589 20.0636 14.5589 19.3127 13.9043L11.7944 22.1303C12.5296 22.799 12.5294 23.8653 12.5294 25.9978Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        opacity="0.35"
        d="M9.18755 6.78841L3.24175 14.2459C0.747176 17.3747 -0.500103 18.9391 0.187166 20.169C0.198545 20.1896 0.210273 20.2097 0.222331 20.2297C0.950377 21.4411 3.10457 21.4411 7.41298 21.4411C9.80719 21.4411 11.0043 21.4411 11.7551 22.0958L11.794 22.1303L19.3123 13.9044L19.2734 13.8698C18.5383 13.201 18.5383 12.1347 18.5383 10.0023V9.44483C18.5383 3.53249 18.5383 0.576329 16.7455 0.0669825C14.9526 -0.442346 13.0308 1.96789 9.18755 6.78841Z"
        fill={`url(#${gradientId})`}
      />
      <path
        opacity="0.35"
        d="M12.5294 25.9978V26.5551C12.5294 32.4673 12.5294 35.4237 14.3222 35.9329C16.1151 36.4423 18.0368 34.0321 21.8803 29.2115L27.826 21.7541C30.3207 18.6253 31.5679 17.0609 30.8807 15.8308C30.8692 15.8105 30.8576 15.7903 30.8456 15.7703C30.1174 14.5589 27.9633 14.5589 23.6548 14.5589C21.2607 14.5589 20.0636 14.5589 19.3127 13.9043L11.7944 22.1303C12.5296 22.799 12.5294 23.8653 12.5294 25.9978Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}
